import './tab-bar.scss';

import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import classnames from 'classnames';

import constants from 'common/signature-modal/constants';

import CameraIcon from 'hellospa/icons/camera';
import ClockIcon from 'hellospa/icons/clock';
import KeyboardIcon from 'hellospa/icons/keyboard';
import PenIcon from 'hellospa/icons/pen';

const messages = defineMessages({
  drawItIn: {
    id: '',
    description: 'Label text for an icon that allows the user to draw in their signature.',
    defaultMessage: 'Draw it in',
  },
  typeItIn: {
    id: '',
    description: 'Label text for an icon that allows the user to type in their signature.',
    defaultMessage: 'Type it in',
  },
  upload: {
    id: '',
    description: 'Label text for an icon that allows the user to upload an image of their signature.',
    defaultMessage: 'Upload',
  },
  saved: {
    id: '',
    description: 'Label text for an icon that allows the user to view their saved signature.',
    defaultMessage: 'Saved',
  },
});

class TabBar extends React.PureComponent {

  onTabSelect = (tab) => () => {
    this.props.onTabSelect(tab);
  };

  isTabEnabled(tab) {
    if (this.props.enabledTabs) {
      return this.props.enabledTabs.includes(tab);
    }

    return true;
  }

  shouldShowTab(tab) {
    const { selectedTab, signatures } = this.props;
    if (tab === constants.TAB_SAVED) {
      return (signatures.length > 0
        && (selectedTab === constants.TAB_SAVED || this.isTabEnabled(constants.TAB_SAVED)));
    } else {
      return this.props.selectedTab === tab || this.isTabEnabled(tab);
    }
  }

  render() {
    const { intl, selectedTab } = this.props;

    return (
      <div className="signature-modal-tab-bar">
        <ol className="signature-modal-tab-bar__list">
          {/* Draw signature tab */}
          {this.shouldShowTab(constants.TAB_DRAW) && (
            <li
              onClick={this.onTabSelect(constants.TAB_DRAW)}
              title={intl.formatMessage(messages.drawItIn)}
              data-qa-ref={`signing-modal--${constants.TAB_DRAW}`}
              className={
                classnames('signature-modal-tab-bar__list-item', {
                  'signature-modal-tab-bar__list-item--is-selected whitelabel-signature-modal-tab': selectedTab === constants.TAB_DRAW,

                })
              }
            >
              <PenIcon className="signature-modal-tab-bar__icon" />
            </li>
          )}
          {/* Type signature tab */}
          {this.shouldShowTab(constants.TAB_TYPE) && (
            <li
              onClick={this.onTabSelect(constants.TAB_TYPE)}
              title={intl.formatMessage(messages.typeItIn)}
              data-qa-ref={`signing-modal--${constants.TAB_TYPE}`}
              className={
                classnames('signature-modal-tab-bar__list-item', {
                  'signature-modal-tab-bar__list-item--is-selected whitelabel-signature-modal-tab': selectedTab === constants.TAB_TYPE,
                })
              }
            >
              <KeyboardIcon className="signature-modal-tab-bar__icon" />
            </li>
          )}
          {/* Upload signature tab */}
          {this.shouldShowTab(constants.TAB_UPLOAD) && (
            <li
              onClick={this.onTabSelect(constants.TAB_UPLOAD)}
              title={intl.formatMessage(messages.upload)}
              data-qa-ref={`signing-modal--${constants.TAB_UPLOAD}`}
              className={
                classnames('signature-modal-tab-bar__list-item', {
                  'signature-modal-tab-bar__list-item--is-selected whitelabel-signature-modal-tab': selectedTab === constants.TAB_UPLOAD,
                })
              }
            >
              <CameraIcon className="signature-modal-tab-bar__icon" />
            </li>
          )}
          {/* Saved signature tab */}
          {this.shouldShowTab(constants.TAB_SAVED) && (
            <li
              onClick={this.onTabSelect(constants.TAB_SAVED)}
              title={intl.formatMessage(messages.saved)}
              data-qa-ref={`signing-modal--${constants.TAB_SAVED}`}
              className={
                classnames('signature-modal-tab-bar__list-item', {
                  'signature-modal-tab-bar__list-item--is-selected whitelabel-signature-modal-tab': selectedTab === constants.TAB_SAVED,
                })
              }
            >
              <ClockIcon className="signature-modal-tab-bar__icon" />
            </li>
          )}
        </ol>
      </div>
    );
  }
}

export default injectIntl(TabBar);
